module.exports = __webpack_public_path__ + "static/media/meditation15.0e0fe8d8.mp3";